// src/services/urls.js

const SERVER_CONFIG = {
    //   exportUrl: "https://schooltracking.s3.eu-north-1.amazonaws.com/",

    // "http://localhost:8000/api": {
    //   exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
    //   reportUrl: "http://localhost:8000/",
    // },
    "https://school.trackingacademy.in/backend/public/api": {
      exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
      reportUrl: "https://school.trackingacademy.in/backend/public/",
    },
    // "https://institute.dturn.io/backend/public/api": {
    //   exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
    //   reportUrl: "https://institute.dturn.io/backend/public/",
    // },
    // "https://kidspark.trackingacademy.in/backend/public/api": {
    //   exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
    //   reportUrl: "https://kidspark.trackingacademy.in/backend/public/",
    // },
    //  "https://bonnenehrunp.trackingacademy.in/backend/public/api": {
    //     exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
    //     reportUrl: "https://bonnenehrunp.trackingacademy.in/backend/public/",
    //   },
    // "https://bonnenehruhr.trackingacademy.in/backend/public/api": {
    //     exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
    //     reportUrl: "https://bonnenehruhr.trackingacademy.in/backend/public/",
    //   },
  //  "https://bestschool.trackingacademy.in/backend/public/api": {
  //     exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
  //     reportUrl: "https://bestschool.trackingacademy.in/backend/public/",
  //   },
  };
  
  export function getServerUrls() {
    const baseUrl = localStorage.getItem("activeBaseUrl");
  
    return SERVER_CONFIG[baseUrl] || {
      exportUrl: "https://pub-26a6d21d158e4065868d4bdaa683f04b.r2.dev/",
      reportUrl: "https://school.trackingacademy.in/backend/public/",
    };
  }
  